import { Clock3 } from 'lucide-react'

export function AgentPage() {
  return (
    <div className="grid h-full place-items-center bg-page p-6">
      <section className="w-full max-w-lg rounded-2xl border border-line bg-surface p-8 text-center shadow-card">
        <span className="mx-auto grid size-11 place-items-center rounded-xl bg-inset text-ink-500 shadow-hairline">
          <Clock3 size={20} />
        </span>
        <div className="mx-auto mt-5 w-fit rounded-full bg-inset px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.08em] text-ink-500 shadow-hairline">
          Coming soon
        </div>
        <h1 className="mt-3 text-xl font-semibold tracking-tight text-ink-900">Agent</h1>
        <p className="mx-auto mt-2 max-w-sm text-sm leading-relaxed text-ink-500">
          Parked for now while the calendar, post composer, publishing, and reporting workflows get
          the attention they deserve.
        </p>
      </section>
    </div>
  )
}
